"use client";

import { TextareaAutosize, styled } from "@mui/material";
import { ChangeEvent } from "react";

interface StyledTextareaProps {
  placeholder: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  maxRows: number;
  value: string;
}
export const StyledTextarea = styled(TextareaAutosize)<StyledTextareaProps>`
  width: 100%;
  height: 100% !important;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  box-sizing: border-box;
  padding: ${({
    theme: {
      functions: { pxToRem },
    },
  }) => pxToRem(8)};
  border-radius: ${({ theme: { borders } }) => borders.borderRadius.xl};

  &:hover {
    border: 2px solid ${({ theme: { palette } }) => palette.primary.main};
  }

  &:focus {
    border: 2px solid ${({ theme: { palette } }) => palette.primary.main};
  }
  &:focus-visible {
    border: 2px solid ${({ theme: { palette } }) => palette.primary.main};
    outline: none;
  }

  firefox &:focus-visible {
    outline: 0;
  }
`;
